export default __webpack_public_path__ + "static/media/war.0adfd9e5.png";